const apiUrl = process.env.REACT_APP_API_URL;
export const PutPaginaRol = async ( id_pagina : number, id_rol : number , editar : boolean , page : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8071/usuaris/pagina`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify({ id_pagina, id_rol, editar })
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
